import axios from 'axios';
import { getApiUrl } from './api';
import { uploadScanInChunks, CHUNK_MIN_SIZE } from './scanUpload';

const CATS = ['Entrées', 'Plats', 'Desserts', 'Boissons', 'Accompagnements', 'Petit-déjeuner'];
const categorie = (c) => (CATS.includes(`${c}s`) ? `${c}s` : c === 'Entrée' ? 'Entrées' : c === 'Dessert' ? 'Desserts' : CATS.includes(c) ? c : 'Plats');
const dormir = (ms) => new Promise((r) => setTimeout(r, ms));
const erreur = (detail) => { const e = new Error(detail); e.detail = detail; return e; };

/** Lit une carte (PDF ou photo) : renvoie les plats { key, nom_plat, prix_vente, sous_categorie, ingredients, etapes, notes_chef, allergenes, portions }. onProgress(texte). */
export async function lireCarte(file, onProgress) {
  const mo = (file.size / 1048576).toFixed(1);
  let pageStart = 0, total = 0, fileRef = null;
  const plats = [];
  do {
    onProgress?.(pageStart > 0 ? `${file.name} · pages ${pageStart + 1}-${Math.min(pageStart + 6, total)} / ${total}` : `${file.name} · envoi (${mo} Mo)…`);
    let job;
    if (!fileRef && file.size > CHUNK_MIN_SIZE) job = await uploadScanInChunks(file, { pageStart, onProgress: (p) => onProgress?.(`${file.name} · envoi ${Math.round(p * 100)} %…`) });
    else {
      const fd = new FormData(); fd.append('page_start', String(pageStart)); fd.append('mode', 'async');
      if (fileRef) fd.append('file_ref', fileRef); else fd.append('image', file);
      job = (await axios.post(`${getApiUrl()}/fiches-techniques/scan`, fd, { withCredentials: true, headers: { 'Content-Type': 'multipart/form-data' }, timeout: 0 })).data;
    }
    if (job?.file_ref) fileRef = job.file_ref;
    let data = job;
    if (job?.job_id) {
      const t0 = Date.now();
      for (;;) {
        await dormir(2000);
        const { data: st } = await axios.get(`${getApiUrl()}/fiches-techniques/scan/${job.job_id}`, { withCredentials: true });
        if (st.status === 'done') { data = st.result; break; }
        if (st.status === 'error') throw erreur(st.detail || 'Lecture impossible');
        if (Date.now() - t0 > 15 * 60 * 1000) throw erreur('Lecture trop longue — réessayez avec moins de pages.');
        onProgress?.(`${file.name}${total ? ` · pages ${pageStart + 1}-${Math.min(pageStart + 6, total)} / ${total}` : ''} · lecture (${Math.round((Date.now() - t0) / 1000)} s)…`);
      }
    }
    total = data.pdf_pages?.total || 0;
    pageStart = data.pdf_pages ? data.pdf_pages.end : total;
    (data.plats?.length ? data.plats : data.nom_plat ? [data] : []).forEach((p, i) => plats.push({
      key: `${file.name}-${pageStart}-${i}`, nom_plat: p.nom_plat || 'Sans nom', prix_vente: p.prix_vente ? Number(p.prix_vente) : null, sous_categorie: categorie(p.categorie),
      portions: p.portions || 1, ingredients: (p.ingredients || []).map((g) => ({ nom: g.nom, quantite: g.quantite, unite: g.unite })), etapes: p.etapes || [], notes_chef: p.notes_chef || '', allergenes: p.allergenes || [],
    }));
  } while (pageStart < total);
  return plats;
}
